/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as keys from "../../constants/keys";
//Removes disabled dropdown items and submenus from array of child elements
const parseChildren = (arr) => {
    return arr.filter(el => {
        return el.getAttributeNames().includes('disabled') === false && !el['ariaDisabled'];
    });
};
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/*
Handles down arrow press when ref.current argument exists.

If an item inside the dropdown isn't focused, it focuses the first element.
If an item inside the dropdown is focused and isn't the last element of the element array, it focuses the next valid item in the array
If an item inside the dropdown is focused, and IS the last element of the element array, it focuses the first element of the array.
*/
export const handleDownPress = (ref) => {
    var _a, _b, _c;
    if (ref.current && document.activeElement) {
        const refChildren = parseChildren(Array.from(ref.current.children));
        if (refChildren.includes(document.activeElement)) {
            if (refChildren[refChildren.length - 1] === document.activeElement) {
                ;
                (_a = refChildren[0]) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                ;
                (_b = refChildren[refChildren.indexOf(document.activeElement) + 1]) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
        else {
            if ((document === null || document === void 0 ? void 0 : document.getElementById('submenu')) === null) {
                ;
                (_c = refChildren[0]) === null || _c === void 0 ? void 0 : _c.focus();
            }
        }
    }
};
/*
Handles up arrow press when ref.current argument exists.

If an item inside the dropdown isn't focused, it focuses the first element.
If an item inside the dropdown is focused and isn't the first element of the element array, it focuses the previous valid item in the array
If an item inside the dropdown is focused, and IS the first element of the element array, it focuses the last element of the array.
*/
export const handleUpPress = (ref) => {
    var _a, _b, _c;
    if (ref.current && document.activeElement) {
        const refChildren = parseChildren(Array.from(ref.current.children));
        if (refChildren.includes(document.activeElement)) {
            if (refChildren[0] === document.activeElement) {
                ;
                (_a = refChildren[refChildren.length - 1]) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                ;
                (_b = refChildren[refChildren.indexOf(document.activeElement) - 1]) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
        else {
            if (!(document === null || document === void 0 ? void 0 : document.getElementById('submenu'))) {
                ;
                (_c = refChildren[0]) === null || _c === void 0 ? void 0 : _c.focus();
            }
        }
    }
};
/*
Handles space bar press when ref.current argument exists.

If focus is on item in dropdown, dispatches click event on said item.
*/
export const handleSpacePress = (ref) => {
    if (ref.current && document.activeElement) {
        const refChildren = parseChildren(Array.from(ref.current.children));
        if (refChildren.includes(document.activeElement)) {
            document.activeElement.dispatchEvent(new Event('click'));
        }
    }
};
/*
Handles right arrow key press.
Only implemented for SubMenu trigger

If focus is on SubMenu trigger in dropdown, and SubMenu is open, focuses first valid item in SubMenu
*/
export const handleRightPress = (contentRef, triggerRef) => {
    var _a;
    if (contentRef.current && document.activeElement) {
        const focusChildren = parseChildren(Array.from(document.activeElement.children));
        const contentChildren = parseChildren(Array.from(contentRef.current.children));
        if (focusChildren.includes(triggerRef.current)) {
            ;
            (_a = contentChildren[0]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }
};
/*
Handles left arrow key press.
Only implemented for SubMenu trigger

If focus is on any item in SubMenu, and SubMenu is open, focuses SubMenu trigger
*/
export const handleLeftPress = (contentRef, triggerRef) => {
    var _a;
    if (contentRef.current && document.activeElement) {
        const contentChildren = parseChildren(Array.from(contentRef.current.children));
        if (contentChildren.includes(document.activeElement)) {
            ;
            (_a = triggerRef.current.parentElement) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }
};
/* eslint-enable @typescript-eslint/no-non-null-assertion */
/*
Handles tab key press.

If focus is on any item in Dropdown, focuses Dropdown button
*/
export const handleTabPress = (e, ref, buttonRef) => {
    var _a;
    if (e.key === keys.TAB) {
        if (ref.current) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            e.stopImmediatePropagation();
        }
    }
};
